export default __webpack_public_path__ + "static/media/try-browser.03575952.svg";